<mat-toolbar class="toolbar-subtitle">
  <mat-toolbar-row>Basic information</mat-toolbar-row>
</mat-toolbar>

@if (displayGymlibBackOfficeLink) {
  <div class="gymlib-info">
    <a
      class="gym-link"
      target="_blank"
      href="{{ gymlibBackOfficeUrl }}"
      rel="noopener">
      View gymlib backoffice
      <mat-icon>north_east</mat-icon>
    </a>
  </div>
}
<div class="flex-display">
  <mat-form-field class="form-column flex-50">
    <mat-label>Gym Alias</mat-label>
    <input
      matInput
      placeholder="Gym Alias"
      [(ngModel)]="alias"
      name="gym.alias"
      id="gym.alias"
      [disabled]="!editMode" />
  </mat-form-field>

  @if (studioTypes) {
    <mat-form-field class="form-column flex-50">
      <mat-label>Studio Type</mat-label>
      <mat-select
        [(ngModel)]="studioType"
        name="gym.studioType"
        [disabled]="!editMode">
        @for (sType of studioTypes; track sType) {
          <mat-option [value]="sType.name">{{
            sType.value
          }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }
</div>

<div class="margin-bottom-1em">
  <mat-checkbox
    name="gym.profilePagePublic"
    [(ngModel)]="profilePagePublic"
    [disabled]="!editMode">
    Public profile page
  </mat-checkbox>
  <br />
  <span class="additional-info">
    When the gym is public it will appear on the gymfinder website and the gym
    details page will be available.
  </span>
</div>

<div class="margin-bottom-1em">
  <mat-checkbox
    name="gym.visibleInBusinessSuite"
    [(ngModel)]="visibleInBusinessSuite"
    [disabled]="!editMode">
    Wellpass tab in Business Suite
  </mat-checkbox>
  <br />
  <span class="additional-info">
    When this checkbox is activated the Wellpass tab shows up in Business Suite.
  </span>
</div>

<div class="margin-bottom-1em">
  <mat-checkbox
    name="gym.disableStudioPageEditing"
    [(ngModel)]="disableStudioPageEditing"
    [disabled]="!editMode">
    Block this gym from editing studio page data via Business Suite
  </mat-checkbox>
  <br />
  <span class="additional-info">
    When checked, this gym can no longer edit its studio page (Business Profile)
    data in the Business Suite. Editing is disabled for all users of this gym;
    view mode still works.
  </span>
</div>
